import * as React from 'react';
import { Loader2Icon } from 'lucide-react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@noor/lib/cn';

const spinnerVariants = cva('animate-spin text-spinner-indicator', {
  variants: {
    size: {
      xs: 'size-3',
      sm: 'size-4',
      default: 'size-5',
      lg: 'size-6',
      xl: 'size-8',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

function Spinner({
  className,
  size,
  label = 'Loading',
  ...props
}: React.ComponentProps<'span'> &
  VariantProps<typeof spinnerVariants> & {
    /** Visually-hidden text announced by assistive tech. Defaults to "Loading". */
    label?: string;
  }) {
  return (
    <span
      data-slot="spinner"
      role="status"
      aria-label={label}
      className={cn('inline-flex', className)}
      {...props}
    >
      <Loader2Icon aria-hidden="true" className={cn(spinnerVariants({ size }))} />
      <span className="sr-only">{label}</span>
    </span>
  );
}

export { Spinner, spinnerVariants };
